"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nameRegex = exports.getNameRegex = void 0;
var getNameRegex = function () { return /^(?=.*\S).+$/; }; // match any string with at least one non-whitespace character
exports.getNameRegex = getNameRegex;
exports.nameRegex = (0, exports.getNameRegex)();
